import SelectKngCatelogSource from './src/main.vue';

/* istanbul ignore next */
SelectKngCatelogSource.install = function(Vue) {
  Vue.component(SelectKngCatelogSource.name, SelectKngCatelogSource);
};

export default SelectKngCatelogSource;
